import { FormattedMessage, FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM, BrandS } from '@sorare/core/src/atoms/typography';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import { RewardConfigImage } from '@sorare/core/src/components/rewards/AnyRewardConfig/RewardConfigImage';
import { useCurrentUserCurrencies } from '@sorare/core/src/hooks/useCurrentUserCurrencies';
import { useMonetaryAmount } from '@sorare/core/src/hooks/useMonetaryAmount';

const Content = styled.div`
  padding: var(--triple-unit) var(--quadruple-unit);
`;
const Padding = styled.div`
  padding: var(--double-unit);
`;
const BezelWrapper = styled.div`
  position: relative;
  &::before,
  &::after {
    content: '';
    position: absolute;
    height: 10px;
    top: 100%;
    left: 0;
    right: 0;
  }
  &::before {
    background: radial-gradient(
      ellipse 55% 5px at top,
      #974dff 0%,
      #974dff 20%,
      transparent 100%
    );
    filter: blur(2px);
  }
  &::after {
    background: radial-gradient(
      ellipse 55% 20px at top,
      #974dff 0%,
      #974dff 20%,
      transparent 100%
    );
    filter: blur(8px);
  }
`;

const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

export const EnterPro = () => {
  const { usd, getUserFiatAmountInMajorUnit } = useMonetaryAmount();
  const { fiatCurrency } = useCurrentUserCurrencies();
  const cashPrizeInDollars = 5000;
  const cashPrizeMonetaryAmount = usd(cashPrizeInDollars * 100);

  return (
    <Bezel borderColor="var(--c-nd-200)">
      <StyledTextureBackground
        background="wave1"
        mode="light"
        color="#3700FF"
        withDots
      />
      <Content className="text-center">
        <Vertical center gap={3}>
          <Vertical center>
            <FormattedMessage
              id="IntroducingRoadToPro.enterPro.title2"
              defaultMessage="<em>Enter Pro</em><label>to win legendary rewards</label>"
              values={{
                em: chunks => <BrandM>{chunks}</BrandM>,
                label: chunks => (
                  <BodyM color="var(--c-nd-600)">{chunks}</BodyM>
                ),
              }}
            />
          </Vertical>
          <BezelWrapper>
            <Bezel borderColor="#974DFF" background="var(--c-black)">
              <Padding>
                <Horizontal center gap={2}>
                  <RewardConfigImage
                    anyRewardConfig={{
                      __typename: 'MonetaryRewardConfig',
                      id: '1',
                    }}
                    size={4}
                  />
                  <BrandS>
                    <FormattedMessage
                      id="IntroducingRoadToPro.enterPro.rewardAmount"
                      defaultMessage="<em>{amount}</em> this gameweek"
                      values={{
                        amount: (
                          <FormattedNumber
                            style="currency"
                            currency={fiatCurrency}
                            value={getUserFiatAmountInMajorUnit(
                              cashPrizeMonetaryAmount
                            )}
                            currencyDisplay="narrowSymbol"
                            maximumFractionDigits={0}
                          />
                        ),
                        em: chunks => <BrandM as="span">{chunks}</BrandM>,
                      }}
                    />
                  </BrandS>
                </Horizontal>
              </Padding>
            </Bezel>
          </BezelWrapper>
        </Vertical>
      </Content>
    </Bezel>
  );
};
